import { RootState } from '../../types';

export const all = (state: RootState) => state.games.current;
export const game = (state: RootState) => all(state).game;
export const loading = (state: RootState) => all(state).loading;
export const loadedId = (state: RootState) => all(state).loadingId;
export const technology = (state: RootState) => game(state).technology;
